export interface DelayBlockModelInterface {
    interval: number;
    unit: string;
    type: string;
    condition?: any
}

export class DelayBlockModel implements DelayBlockModelInterface {
    interval: number = 0;
    type: string = 'default';
    unit: string = 'Hours';
    condition: any | null = null;

    constructor(data: object = undefined) {
        if(data) {
            for( const key in data ) {
                if(this.hasOwnProperty(key)) {
                    this[key] = data[key];
                }
            }
        }
    }
}
